<div class="col-md-12 col-lg-12">
    <div class="panel panel-default">
        <div class="panel-heading">
            <h3 class="panel-title"></h3>
        </div>
        <div class="panel-body">
            <!-- <div class="alert alert-success">
                <strong class="default"><i class="far fa-check-circle"></i> Quegangazo</strong>: Fecha<br>
                <span>Mensaje 2</span>
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            </div>

            <div class="alert alert-info">
                <strong class="default"><i class="fas fa-info-circle"></i> Quegangazo</strong>: Fecha<br>
                <span>Mensaje 2</span>
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            </div> -->

            <!-- <div class="alert alert-warning">
                <strong class="default"><i class="fas fa-exclamation-triangle"></i>Quegangazo</strong>: Fecha<br>
                <span>Mensaje 2</span>
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            </div> -->

            <!-- <div class="alert alert-danger">
                <strong class="default"><i class="fas fa-exclamation-circle"></i> Quegangazo</strong>: Fecha<br>
                <span>Mensaje 2</span>
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            </div> -->

            <div *ngIf="mensajes">
                <div class="alert"
                    [ngClass]="{'alert-success': mensaje.tipo === 1, 'alert-info':  mensaje.tipo === 2, 'alert-warning':  mensaje.tipo === 3 , 'alert-danger':  mensaje.tipo === 4}"
                    *ngFor="let mensaje of mensajes">
                    <strong class="default">
                        <span [ngSwitch]="mensaje.tipo">
                            <i *ngSwitchCase="1" class="far fa-check-circle"></i>
                            <i *ngSwitchCase="2" class="fas fa-info-circle"></i>
                            <i *ngSwitchCase="3" class="fas fa-exclamation-triangle"></i>
                            <i *ngSwitchDefault class="fas fa-exclamation-circle"></i>

                        </span>
                        {{mensaje.enviado_por}}</strong><br>
                    <span class="fecha">{{mensaje.fecha}}</span><br>
                    <span class="mensaje">{{mensaje.mensaje}}</span>
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="no-data" *ngIf="!mensajes">
    No tienes mensajes en tu bandeja de entrada
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>